import { ITagsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class AddTagsToDatasourcesRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToDatasources', {
      ids: ids,
      tags: tags
    });
  }
}
